import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ChannelService
  from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { selectThresholdRangeById } from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { formatThresholdDetails, getThresholdSource } from '../AlertFormUtility';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';

function SharedThresholdSummary({ thresholdId, thresholdData, sensorsData }) {
  const sessionInformation = useSelector(selectSessionInformation);
  const thresholdRangeById = useSelector((state) => selectThresholdRangeById(state, thresholdId));
  const existingThresholdRange = thresholdRangeById || null;

  const thresholdSource = getThresholdSource(sensorsData, thresholdData, existingThresholdRange);
  const thresholdName = thresholdSource.thresholdName || 'Custom Threshold';

  const channelImpl = useMemo(
    () => (sensorsData.selectedChannels[0]
      ? ChannelService.getChannelFromChannelKey(sensorsData.selectedChannels[0])
      : null),
    [sensorsData.selectedChannels],
  );

  const thresholdDetails = useMemo(
    () => formatThresholdDetails(
      thresholdSource.readingType,
      thresholdSource.thresholdOperator,
      thresholdSource.thresholdValue,
      {
        temperatureScale: sessionInformation.temperatureScale,
        airSpeedScale: sessionInformation.airSpeedScale,
      },
      channelImpl,
    ),
    [
      thresholdSource.readingType,
      thresholdSource.thresholdOperator,
      thresholdSource.thresholdValue,
      sessionInformation.temperatureScale,
      sessionInformation.airSpeedScale,
    ],
  );

  return (
    <div className="read-only-threshold-summary">
      <strong>
        {thresholdName}
        {' '}
      </strong>
      {thresholdDetails}
    </div>
  );
}

SharedThresholdSummary.propTypes = {
  thresholdId: PropTypes.number.isRequired,
  thresholdData: PropTypes.shape({}).isRequired,
  sensorsData: PropTypes.shape({ selectedChannels: PropTypes.array }).isRequired,
};
export default SharedThresholdSummary;
